import React from 'react';
import styled from '@emotion/styled';
import type { HeightProps, MaxHeightProps, MaxWidthProps, WidthProps } from 'styled-system';
import { display, height, maxHeight, maxWidth, width } from 'styled-system';

import h24LogoSvg from 'common/assets/images/home-24-logo.svg';
import { H24_IMG_HEIGHT, H24_IMG_WIDTH } from 'common/constants/logo';
import { useLocalization } from 'common/providers/LocaleProvider';
import {
  focusOutlineCSSWithOffsetAndRadius,
  hoverOutlineCSSWithOffsetAndRadius,
} from 'common/theme/styles';

interface LogoProps {
  className?: string;
}

type BrandLogoStyleProps = WidthProps &
  MaxWidthProps &
  HeightProps &
  MaxHeightProps & {
    src: string;
    alt?: string;
  };

const Link = styled.a`
  ${display};
  ${hoverOutlineCSSWithOffsetAndRadius};
  ${focusOutlineCSSWithOffsetAndRadius};
`;
const linkStyles = {
  display: 'flex',
};

const BrandLogo = styled.img<any>`
  ${width};
  ${maxWidth};
  ${height};
  ${maxHeight};
`;
const brandLogoStyles: BrandLogoStyleProps = {
  src: h24LogoSvg,
  width: H24_IMG_WIDTH,
  maxWidth: H24_IMG_WIDTH,
  height: H24_IMG_HEIGHT,
  maxHeight: H24_IMG_HEIGHT,
};

const Logo = ({ className }: LogoProps) => {
  const { t, prefix } = useLocalization();

  return (
    <Link
      href={prefix(t('h24_home_url'))}
      aria-label={t('h24_homepage_link')}
      className={className}
      {...linkStyles}
    >
      <BrandLogo alt="" {...brandLogoStyles} />
    </Link>
  );
};

export default Logo;
